import { Badge, BadgeProps } from '@fluentui/react-components';

type TConfidence = {
  color: Extract<BadgeProps['color'], 'success' | 'warning' | 'danger'>;
  label: string;
};

const resolveConfidence = (confidence: number): TConfidence => {
  if (confidence >= 0.7) return { color: 'success', label: 'High confidence' };
  if (confidence >= 0.4) return { color: 'warning', label: 'Medium confidence' };
  return { color: 'danger', label: 'Low confidence' };
};

type TProps = {
  confidence: number;
};

const ConfidenceBadge = ({ confidence }: TProps) => {
  const { color, label } = resolveConfidence(confidence);
  return (
    <Badge appearance="tint" color={color}>
      {label}
    </Badge>
  );
};

export default ConfidenceBadge;
